import axios from './axiosConfig'

export type TenantInfoResponse = {
 status: string
 data?: {
 tenant?: {
 id: string
 name: string
 slug: string
 domain?: string | null
 timezone?: string | null
 contact_info?: {
 company_name?: string | null
 cr_number?: string | null
 logo_url?: string | null
 [k: string]: unknown
 } | null
 settings?: {
 theme?: {
 primary_hex?: string | null
 } | null
 [k: string]: unknown
 } | null
 }
 }
 message?: string
}

export const tenantAPI = {
 info: async () => {
 const res = await axios.get<TenantInfoResponse>('/tenant/info')
 return res.data
 },

 getTheme: async () => {
 const res = await axios.get<{ status: string; data?: { primary_hex?: string | null }; message?: string }>(
 '/tenant/theme'
 )
 return res.data
 },

 updateTheme: async (primary_hex: string) => {
 const res = await axios.put<{ status: string; data?: { primary_hex?: string | null }; message?: string }>(
 '/tenant/theme',
 { primary_hex }
 )
 return res.data
 },
}

